module.exports = __webpack_public_path__ + "img/exel-btn.2828555d.svg";